import { cloneVNode as i } from "vue";
function o(n) {
  const {
    length: e
  } = n;
  return e > 1 && (n.push(t(n[0], 0, "append")), n.unshift(t(n[e - 1], e - 1, "prepend"))), n;
}
function t(n, e, u) {
  return i(n, {
    // for patch
    key: `carousel-item-duplicate-${e}-${u}`
  });
}
function p(n, e, u) {
  return e === 1 ? 0 : u ? n === 0 ? e - 3 : n === e - 1 ? 0 : n - 1 : n;
}
function r(n, e) {
  return e ? n + 1 : n;
}
function l(n, e, u) {
  return n < 0 ? null : n === 0 ? u ? e - 1 : null : n - 1;
}
function a(n, e, u) {
  return n > e - 1 ? null : n === e - 1 ? u ? 0 : null : n + 1;
}
function d(n, e) {
  return e && n > 3 ? n - 2 : n;
}
export {
  o as addDuplicateSlides,
  p as getDisplayIndex,
  d as getDisplayTotalView,
  a as getNextIndex,
  l as getPrevIndex,
  r as getRealIndex
};
